module.exports = "/virtual-football-league/img/amblems/left/logos/Fake_Bournmouth.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Fake_Bournmouth.png
// module id = 2076
// module chunks = 4